"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterParentFilteringProvider = exports.useAttributeFilterParentFiltering = exports.AttributeFilterParentFiltering = void 0;
var tslib_1 = require("tslib");
// (C) 2022-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../model");
var dashboardFilterConverter_1 = require("../../../_staging/dashboard/dashboardFilterConverter");
var useParentsConfiguration_1 = require("./dashboardDropdownBody/configuration/hooks/useParentsConfiguration");
var useDisplayFormConfiguration_1 = require("./dashboardDropdownBody/configuration/hooks/useDisplayFormConfiguration");
exports.AttributeFilterParentFiltering = react_1.default.createContext(null); // TODO: Fix typing
exports.AttributeFilterParentFiltering.displayName = "AttributeFilterParentFiltering";
/**
 * @internal
 */
exports.useAttributeFilterParentFiltering = function () {
    return react_1.useContext(exports.AttributeFilterParentFiltering);
};
/**
 * @internal
 */
exports.AttributeFilterParentFilteringProvider = function (props) {
    var children = props.children, currentFilter = props.filter, attributes = props.attributes;
    var attributeFilter = react_1.useMemo(function () { return dashboardFilterConverter_1.dashboardAttributeFilterToAttributeFilter(currentFilter); }, [currentFilter]);
    var filterRef = react_1.useMemo(function () {
        return sdk_model_1.filterObjRef(attributeFilter);
    }, [attributeFilter]);
    var neighborFilters = model_1.useDashboardSelector(model_1.selectOtherContextAttributeFilters(filterRef));
    var _a = useParentsConfiguration_1.useParentsConfiguration(neighborFilters, currentFilter), parents = _a.parents, configurationChanged = _a.configurationChanged, onParentSelect = _a.onParentSelect, onConnectingAttributeChanged = _a.onConnectingAttributeChanged, onParentFiltersChange = _a.onParentFiltersChange, onParentFiltersClose = _a.onConfigurationClose;
    var _b = useDisplayFormConfiguration_1.useDisplayFormConfiguration(currentFilter, attributes), onDisplayFormSelect = _b.onDisplayFormSelect, filterDisplayForms = _b.filterDisplayForms, displayFormChanged = _b.displayFormChanged, onDisplayFormChange = _b.onDisplayFormChange, onDisplayFormClose = _b.onConfigurationClose, displayFormChangeStatus = _b.displayFormChangeStatus;
    var onConfigurationSave = react_1.useCallback(function () {
        onParentFiltersChange();
        onDisplayFormChange();
    }, [onParentFiltersChange, onDisplayFormChange]);
    var onConfigurationClose = react_1.useCallback(function () {
        onParentFiltersClose();
        onDisplayFormClose();
    }, [onParentFiltersClose, onDisplayFormClose]);
    var showDisplayFormPicker = filterDisplayForms.availableDisplayForms.length > 1;
    return (react_1.default.createElement(exports.AttributeFilterParentFiltering.Provider, { value: {
            parents: parents,
            onParentSelect: onParentSelect,
            onConnectingAttributeChanged: onConnectingAttributeChanged,
            onParentFiltersChange: onParentFiltersChange,
            onDisplayFormSelect: onDisplayFormSelect,
            filterDisplayForms: filterDisplayForms,
            displayFormChanged: displayFormChanged,
            onDisplayFormChange: onDisplayFormChange,
            onConfigurationSave: onConfigurationSave,
            onConfigurationClose: onConfigurationClose,
            showDisplayFormPicker: showDisplayFormPicker,
            configurationChanged: configurationChanged,
            displayFormChangeStatus: displayFormChangeStatus,
        } }, children));
};
//# sourceMappingURL=AttributeFilterParentFilteringContext.js.map